import React from "react";

import "./styles.scss"
import ChatHistoryMain from "../../esg-chat/chat-history";

const CustomHistory = () => {
    return (
        <>
            <ChatHistoryMain model="Custom" searchBy="Private" />
        </>
    )
}

export default CustomHistory